import { render, staticRenderFns } from "./EditRating.vue?vue&type=template&id=87cdbebc&scoped=true&"
import script from "./EditRating.vue?vue&type=script&lang=js&"
export * from "./EditRating.vue?vue&type=script&lang=js&"
import style0 from "./EditRating.vue?vue&type=style&index=0&id=87cdbebc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cdbebc",
  null
  
)

export default component.exports